import _ from 'lodash';
import { FC, InputHTMLAttributes, useState } from 'react';

interface UserInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  id: string;
  value: string | number;
  onHandleChange: (value: string) => void;
  type?: string;
  isDisabled?: boolean;
  labelValue?: string;
  placeholder?: string;
  autoFocus?: boolean;
  required?: boolean;
}

const UserInput: FC<UserInputProps> = ({
  id,
  value,
  onHandleChange,
  type = 'text',
  isDisabled = false,
  labelValue,
  placeholder = '',
  autoFocus = false,
  required = true,
  ...rest
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const effectiveType = type === 'password' ? (isPasswordVisible ? 'text' : type) : type;
  const labelId = id ?? _.random(1, 1000000);

  return (
    <div className="user-input__container">
      {labelValue && <label htmlFor={labelId}>{labelValue}</label>}
      <div className="input-group">
        <input
          className="form-control"
          type={effectiveType}
          id={labelId}
          disabled={isDisabled}
          value={value}
          placeholder={placeholder}
          onChange={(event) => {
            event.preventDefault();
            onHandleChange(event.target.value);
          }}
          autoFocus={autoFocus}
          required={required}
          {...rest}
        />
        {type === 'password' && (
          <div className="input-group-append" onClick={() => setIsPasswordVisible(!isPasswordVisible)}>
            {isPasswordVisible ? <i className="fa-solid fa-eye" /> : <i className="fa-solid fa-eye-slash" />}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserInput;
